/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
export const protobufPackage = "xmtp.mls.message_contents";
/**
 * Message content encoding structures
 * Copied from V2 code so that we can eventually retire all V2 message content
 */
/**
 * Recognized compression algorithms
 * protolint:disable ENUM_FIELD_NAMES_ZERO_VALUE_END_WITH
 */
export var Compression;
(function (Compression) {
  Compression[Compression["COMPRESSION_DEFLATE"] = 0] = "COMPRESSION_DEFLATE";
  Compression[Compression["COMPRESSION_GZIP"] = 1] = "COMPRESSION_GZIP";
  Compression[Compression["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Compression || (Compression = {}));
export function compressionFromJSON(object) {
  switch (object) {
    case 0:
    case "COMPRESSION_DEFLATE":
      return Compression.COMPRESSION_DEFLATE;
    case 1:
    case "COMPRESSION_GZIP":
      return Compression.COMPRESSION_GZIP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Compression.UNRECOGNIZED;
  }
}
export function compressionToJSON(object) {
  switch (object) {
    case Compression.COMPRESSION_DEFLATE:
      return "COMPRESSION_DEFLATE";
    case Compression.COMPRESSION_GZIP:
      return "COMPRESSION_GZIP";
    case Compression.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** The kind of device sync payload being sent */
export var DeviceSyncKind;
(function (DeviceSyncKind) {
  DeviceSyncKind[DeviceSyncKind["DEVICE_SYNC_KIND_UNSPECIFIED"] = 0] = "DEVICE_SYNC_KIND_UNSPECIFIED";
  DeviceSyncKind[DeviceSyncKind["DEVICE_SYNC_KIND_MESSAGE_HISTORY"] = 1] = "DEVICE_SYNC_KIND_MESSAGE_HISTORY";
  DeviceSyncKind[DeviceSyncKind["DEVICE_SYNC_KIND_CONSENT"] = 2] = "DEVICE_SYNC_KIND_CONSENT";
  DeviceSyncKind[DeviceSyncKind["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DeviceSyncKind || (DeviceSyncKind = {}));
export function deviceSyncKindFromJSON(object) {
  switch (object) {
    case 0:
    case "DEVICE_SYNC_KIND_UNSPECIFIED":
      return DeviceSyncKind.DEVICE_SYNC_KIND_UNSPECIFIED;
    case 1:
    case "DEVICE_SYNC_KIND_MESSAGE_HISTORY":
      return DeviceSyncKind.DEVICE_SYNC_KIND_MESSAGE_HISTORY;
    case 2:
    case "DEVICE_SYNC_KIND_CONSENT":
      return DeviceSyncKind.DEVICE_SYNC_KIND_CONSENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DeviceSyncKind.UNRECOGNIZED;
  }
}
export function deviceSyncKindToJSON(object) {
  switch (object) {
    case DeviceSyncKind.DEVICE_SYNC_KIND_UNSPECIFIED:
      return "DEVICE_SYNC_KIND_UNSPECIFIED";
    case DeviceSyncKind.DEVICE_SYNC_KIND_MESSAGE_HISTORY:
      return "DEVICE_SYNC_KIND_MESSAGE_HISTORY";
    case DeviceSyncKind.DEVICE_SYNC_KIND_CONSENT:
      return "DEVICE_SYNC_KIND_CONSENT";
    case DeviceSyncKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** The type of entity the user is consenting to */
export var ConsentEntityType;
(function (ConsentEntityType) {
  ConsentEntityType[ConsentEntityType["CONSENT_ENTITY_TYPE_UNSPECIFIED"] = 0] = "CONSENT_ENTITY_TYPE_UNSPECIFIED";
  ConsentEntityType[ConsentEntityType["CONSENT_ENTITY_TYPE_CONVERSATION_ID"] = 1] = "CONSENT_ENTITY_TYPE_CONVERSATION_ID";
  ConsentEntityType[ConsentEntityType["CONSENT_ENTITY_TYPE_INBOX_ID"] = 2] = "CONSENT_ENTITY_TYPE_INBOX_ID";
  ConsentEntityType[ConsentEntityType["CONSENT_ENTITY_TYPE_ADDRESS"] = 3] = "CONSENT_ENTITY_TYPE_ADDRESS";
  ConsentEntityType[ConsentEntityType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ConsentEntityType || (ConsentEntityType = {}));
export function consentEntityTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "CONSENT_ENTITY_TYPE_UNSPECIFIED":
      return ConsentEntityType.CONSENT_ENTITY_TYPE_UNSPECIFIED;
    case 1:
    case "CONSENT_ENTITY_TYPE_CONVERSATION_ID":
      return ConsentEntityType.CONSENT_ENTITY_TYPE_CONVERSATION_ID;
    case 2:
    case "CONSENT_ENTITY_TYPE_INBOX_ID":
      return ConsentEntityType.CONSENT_ENTITY_TYPE_INBOX_ID;
    case 3:
    case "CONSENT_ENTITY_TYPE_ADDRESS":
      return ConsentEntityType.CONSENT_ENTITY_TYPE_ADDRESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConsentEntityType.UNRECOGNIZED;
  }
}
export function consentEntityTypeToJSON(object) {
  switch (object) {
    case ConsentEntityType.CONSENT_ENTITY_TYPE_UNSPECIFIED:
      return "CONSENT_ENTITY_TYPE_UNSPECIFIED";
    case ConsentEntityType.CONSENT_ENTITY_TYPE_CONVERSATION_ID:
      return "CONSENT_ENTITY_TYPE_CONVERSATION_ID";
    case ConsentEntityType.CONSENT_ENTITY_TYPE_INBOX_ID:
      return "CONSENT_ENTITY_TYPE_INBOX_ID";
    case ConsentEntityType.CONSENT_ENTITY_TYPE_ADDRESS:
      return "CONSENT_ENTITY_TYPE_ADDRESS";
    case ConsentEntityType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** Possible states of consent */
export var ConsentState;
(function (ConsentState) {
  ConsentState[ConsentState["CONSENT_STATE_UNSPECIFIED"] = 0] = "CONSENT_STATE_UNSPECIFIED";
  ConsentState[ConsentState["CONSENT_STATE_ALLOWED"] = 1] = "CONSENT_STATE_ALLOWED";
  ConsentState[ConsentState["CONSENT_STATE_DENIED"] = 2] = "CONSENT_STATE_DENIED";
  ConsentState[ConsentState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ConsentState || (ConsentState = {}));
export function consentStateFromJSON(object) {
  switch (object) {
    case 0:
    case "CONSENT_STATE_UNSPECIFIED":
      return ConsentState.CONSENT_STATE_UNSPECIFIED;
    case 1:
    case "CONSENT_STATE_ALLOWED":
      return ConsentState.CONSENT_STATE_ALLOWED;
    case 2:
    case "CONSENT_STATE_DENIED":
      return ConsentState.CONSENT_STATE_DENIED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConsentState.UNRECOGNIZED;
  }
}
export function consentStateToJSON(object) {
  switch (object) {
    case ConsentState.CONSENT_STATE_UNSPECIFIED:
      return "CONSENT_STATE_UNSPECIFIED";
    case ConsentState.CONSENT_STATE_ALLOWED:
      return "CONSENT_STATE_ALLOWED";
    case ConsentState.CONSENT_STATE_DENIED:
      return "CONSENT_STATE_DENIED";
    case ConsentState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseContentTypeId() {
  return {
    authorityId: "",
    typeId: "",
    versionMajor: 0,
    versionMinor: 0
  };
}
export const ContentTypeId = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.authorityId !== "") {
      writer.uint32(10).string(message.authorityId);
    }
    if (message.typeId !== "") {
      writer.uint32(18).string(message.typeId);
    }
    if (message.versionMajor !== 0) {
      writer.uint32(24).uint32(message.versionMajor);
    }
    if (message.versionMinor !== 0) {
      writer.uint32(32).uint32(message.versionMinor);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContentTypeId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.authorityId = reader.string();
          break;
        case 2:
          message.typeId = reader.string();
          break;
        case 3:
          message.versionMajor = reader.uint32();
          break;
        case 4:
          message.versionMinor = reader.uint32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      authorityId: isSet(object.authorityId) ? String(object.authorityId) : "",
      typeId: isSet(object.typeId) ? String(object.typeId) : "",
      versionMajor: isSet(object.versionMajor) ? Number(object.versionMajor) : 0,
      versionMinor: isSet(object.versionMinor) ? Number(object.versionMinor) : 0
    };
  },
  toJSON(message) {
    const obj = {};
    message.authorityId !== undefined && (obj.authorityId = message.authorityId);
    message.typeId !== undefined && (obj.typeId = message.typeId);
    message.versionMajor !== undefined && (obj.versionMajor = Math.round(message.versionMajor));
    message.versionMinor !== undefined && (obj.versionMinor = Math.round(message.versionMinor));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d;
    const message = createBaseContentTypeId();
    message.authorityId = (_a = object.authorityId) !== null && _a !== void 0 ? _a : "";
    message.typeId = (_b = object.typeId) !== null && _b !== void 0 ? _b : "";
    message.versionMajor = (_c = object.versionMajor) !== null && _c !== void 0 ? _c : 0;
    message.versionMinor = (_d = object.versionMinor) !== null && _d !== void 0 ? _d : 0;
    return message;
  }
};
function createBaseEncodedContent() {
  return {
    type: undefined,
    parameters: {},
    fallback: undefined,
    compression: undefined,
    content: new Uint8Array()
  };
}
export const EncodedContent = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.type !== undefined) {
      ContentTypeId.encode(message.type, writer.uint32(10).fork()).ldelim();
    }
    Object.entries(message.parameters).forEach(_ref => {
      let [key, value] = _ref;
      EncodedContent_ParametersEntry.encode({
        key: key,
        value
      }, writer.uint32(18).fork()).ldelim();
    });
    if (message.fallback !== undefined) {
      writer.uint32(26).string(message.fallback);
    }
    if (message.compression !== undefined) {
      writer.uint32(40).int32(message.compression);
    }
    if (message.content.length !== 0) {
      writer.uint32(34).bytes(message.content);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEncodedContent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.type = ContentTypeId.decode(reader, reader.uint32());
          break;
        case 2:
          const entry2 = EncodedContent_ParametersEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.parameters[entry2.key] = entry2.value;
          }
          break;
        case 3:
          message.fallback = reader.string();
          break;
        case 5:
          message.compression = reader.int32();
          break;
        case 4:
          message.content = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      type: isSet(object.type) ? ContentTypeId.fromJSON(object.type) : undefined,
      parameters: isObject(object.parameters) ? Object.entries(object.parameters).reduce((acc, _ref2) => {
        let [key, value] = _ref2;
        acc[key] = String(value);
        return acc;
      }, {}) : {},
      fallback: isSet(object.fallback) ? String(object.fallback) : undefined,
      compression: isSet(object.compression) ? compressionFromJSON(object.compression) : undefined,
      content: isSet(object.content) ? bytesFromBase64(object.content) : new Uint8Array()
    };
  },
  toJSON(message) {
    const obj = {};
    message.type !== undefined && (obj.type = message.type ? ContentTypeId.toJSON(message.type) : undefined);
    obj.parameters = {};
    if (message.parameters) {
      Object.entries(message.parameters).forEach(_ref3 => {
        let [k, v] = _ref3;
        obj.parameters[k] = v;
      });
    }
    message.fallback !== undefined && (obj.fallback = message.fallback);
    message.compression !== undefined && (obj.compression = message.compression !== undefined ? compressionToJSON(message.compression) : undefined);
    message.content !== undefined && (obj.content = base64FromBytes(message.content !== undefined ? message.content : new Uint8Array()));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c, _d;
    const message = createBaseEncodedContent();
    message.type = object.type !== undefined && object.type !== null ? ContentTypeId.fromPartial(object.type) : undefined;
    message.parameters = Object.entries((_a = object.parameters) !== null && _a !== void 0 ? _a : {}).reduce((acc, _ref4) => {
      let [key, value] = _ref4;
      if (value !== undefined) {
        acc[key] = String(value);
      }
      return acc;
    }, {});
    message.fallback = (_b = object.fallback) !== null && _b !== void 0 ? _b : undefined;
    message.compression = (_c = object.compression) !== null && _c !== void 0 ? _c : undefined;
    message.content = (_d = object.content) !== null && _d !== void 0 ? _d : new Uint8Array();
    return message;
  }
};
function createBaseEncodedContent_ParametersEntry() {
  return {
    key: "",
    value: ""
  };
}
export const EncodedContent_ParametersEntry = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEncodedContent_ParametersEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? String(object.value) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBaseEncodedContent_ParametersEntry();
    message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
    message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
    return message;
  }
};
function createBasePlaintextEnvelope() {
  return {
    v1: undefined,
    v2: undefined
  };
}
export const PlaintextEnvelope = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.v1 !== undefined) {
      PlaintextEnvelope_V1.encode(message.v1, writer.uint32(10).fork()).ldelim();
    }
    if (message.v2 !== undefined) {
      PlaintextEnvelope_V2.encode(message.v2, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaintextEnvelope();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.v1 = PlaintextEnvelope_V1.decode(reader, reader.uint32());
          break;
        case 2:
          message.v2 = PlaintextEnvelope_V2.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      v1: isSet(object.v1) ? PlaintextEnvelope_V1.fromJSON(object.v1) : undefined,
      v2: isSet(object.v2) ? PlaintextEnvelope_V2.fromJSON(object.v2) : undefined
    };
  },
  toJSON(message) {
    const obj = {};
    message.v1 !== undefined && (obj.v1 = message.v1 ? PlaintextEnvelope_V1.toJSON(message.v1) : undefined);
    message.v2 !== undefined && (obj.v2 = message.v2 ? PlaintextEnvelope_V2.toJSON(message.v2) : undefined);
    return obj;
  },
  fromPartial(object) {
    const message = createBasePlaintextEnvelope();
    message.v1 = object.v1 !== undefined && object.v1 !== null ? PlaintextEnvelope_V1.fromPartial(object.v1) : undefined;
    message.v2 = object.v2 !== undefined && object.v2 !== null ? PlaintextEnvelope_V2.fromPartial(object.v2) : undefined;
    return message;
  }
};
function createBasePlaintextEnvelope_V1() {
  return {
    content: new Uint8Array(),
    idempotencyKey: ""
  };
}
export const PlaintextEnvelope_V1 = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.content.length !== 0) {
      writer.uint32(10).bytes(message.content);
    }
    if (message.idempotencyKey !== "") {
      writer.uint32(18).string(message.idempotencyKey);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaintextEnvelope_V1();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.content = reader.bytes();
          break;
        case 2:
          message.idempotencyKey = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      content: isSet(object.content) ? bytesFromBase64(object.content) : new Uint8Array(),
      idempotencyKey: isSet(object.idempotencyKey) ? String(object.idempotencyKey) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.content !== undefined && (obj.content = base64FromBytes(message.content !== undefined ? message.content : new Uint8Array()));
    message.idempotencyKey !== undefined && (obj.idempotencyKey = message.idempotencyKey);
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBasePlaintextEnvelope_V1();
    message.content = (_a = object.content) !== null && _a !== void 0 ? _a : new Uint8Array();
    message.idempotencyKey = (_b = object.idempotencyKey) !== null && _b !== void 0 ? _b : "";
    return message;
  }
};
function createBasePlaintextEnvelope_V2() {
  return {
    idempotencyKey: "",
    content: undefined,
    deviceSyncRequest: undefined,
    deviceSyncReply: undefined,
    consentUpdate: undefined
  };
}
export const PlaintextEnvelope_V2 = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.idempotencyKey !== "") {
      writer.uint32(10).string(message.idempotencyKey);
    }
    if (message.content !== undefined) {
      writer.uint32(18).bytes(message.content);
    }
    if (message.deviceSyncRequest !== undefined) {
      DeviceSyncRequest.encode(message.deviceSyncRequest, writer.uint32(26).fork()).ldelim();
    }
    if (message.deviceSyncReply !== undefined) {
      DeviceSyncReply.encode(message.deviceSyncReply, writer.uint32(34).fork()).ldelim();
    }
    if (message.consentUpdate !== undefined) {
      ConsentUpdate.encode(message.consentUpdate, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaintextEnvelope_V2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.idempotencyKey = reader.string();
          break;
        case 2:
          message.content = reader.bytes();
          break;
        case 3:
          message.deviceSyncRequest = DeviceSyncRequest.decode(reader, reader.uint32());
          break;
        case 4:
          message.deviceSyncReply = DeviceSyncReply.decode(reader, reader.uint32());
          break;
        case 5:
          message.consentUpdate = ConsentUpdate.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      idempotencyKey: isSet(object.idempotencyKey) ? String(object.idempotencyKey) : "",
      content: isSet(object.content) ? bytesFromBase64(object.content) : undefined,
      deviceSyncRequest: isSet(object.deviceSyncRequest) ? DeviceSyncRequest.fromJSON(object.deviceSyncRequest) : undefined,
      deviceSyncReply: isSet(object.deviceSyncReply) ? DeviceSyncReply.fromJSON(object.deviceSyncReply) : undefined,
      consentUpdate: isSet(object.consentUpdate) ? ConsentUpdate.fromJSON(object.consentUpdate) : undefined
    };
  },
  toJSON(message) {
    const obj = {};
    message.idempotencyKey !== undefined && (obj.idempotencyKey = message.idempotencyKey);
    message.content !== undefined && (obj.content = message.content !== undefined ? base64FromBytes(message.content) : undefined);
    message.deviceSyncRequest !== undefined && (obj.deviceSyncRequest = message.deviceSyncRequest ? DeviceSyncRequest.toJSON(message.deviceSyncRequest) : undefined);
    message.deviceSyncReply !== undefined && (obj.deviceSyncReply = message.deviceSyncReply ? DeviceSyncReply.toJSON(message.deviceSyncReply) : undefined);
    message.consentUpdate !== undefined && (obj.consentUpdate = message.consentUpdate ? ConsentUpdate.toJSON(message.consentUpdate) : undefined);
    return obj;
  },
  fromPartial(object) {
    var _a, _b;
    const message = createBasePlaintextEnvelope_V2();
    message.idempotencyKey = (_a = object.idempotencyKey) !== null && _a !== void 0 ? _a : "";
    message.content = (_b = object.content) !== null && _b !== void 0 ? _b : undefined;
    message.deviceSyncRequest = object.deviceSyncRequest !== undefined && object.deviceSyncRequest !== null ? DeviceSyncRequest.fromPartial(object.deviceSyncRequest) : undefined;
    message.deviceSyncReply = object.deviceSyncReply !== undefined && object.deviceSyncReply !== null ? DeviceSyncReply.fromPartial(object.deviceSyncReply) : undefined;
    message.consentUpdate = object.consentUpdate !== undefined && object.consentUpdate !== null ? ConsentUpdate.fromPartial(object.consentUpdate) : undefined;
    return message;
  }
};
function createBaseDeviceSyncRequest() {
  return {
    requestId: "",
    pinCode: "",
    kind: 0
  };
}
export const DeviceSyncRequest = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    if (message.pinCode !== "") {
      writer.uint32(18).string(message.pinCode);
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceSyncRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.requestId = reader.string();
          break;
        case 2:
          message.pinCode = reader.string();
          break;
        case 3:
          message.kind = reader.int32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      requestId: isSet(object.requestId) ? String(object.requestId) : "",
      pinCode: isSet(object.pinCode) ? String(object.pinCode) : "",
      kind: isSet(object.kind) ? deviceSyncKindFromJSON(object.kind) : 0
    };
  },
  toJSON(message) {
    const obj = {};
    message.requestId !== undefined && (obj.requestId = message.requestId);
    message.pinCode !== undefined && (obj.pinCode = message.pinCode);
    message.kind !== undefined && (obj.kind = deviceSyncKindToJSON(message.kind));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c;
    const message = createBaseDeviceSyncRequest();
    message.requestId = (_a = object.requestId) !== null && _a !== void 0 ? _a : "";
    message.pinCode = (_b = object.pinCode) !== null && _b !== void 0 ? _b : "";
    message.kind = (_c = object.kind) !== null && _c !== void 0 ? _c : 0;
    return message;
  }
};
function createBaseDeviceSyncReply() {
  return {
    requestId: "",
    url: "",
    encryptionKey: undefined,
    timestampNs: Long.UZERO,
    kind: 0
  };
}
export const DeviceSyncReply = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.encryptionKey !== undefined) {
      DeviceSyncKeyType.encode(message.encryptionKey, writer.uint32(26).fork()).ldelim();
    }
    if (!message.timestampNs.isZero()) {
      writer.uint32(32).uint64(message.timestampNs);
    }
    if (message.kind !== 0) {
      writer.uint32(40).int32(message.kind);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceSyncReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.requestId = reader.string();
          break;
        case 2:
          message.url = reader.string();
          break;
        case 3:
          message.encryptionKey = DeviceSyncKeyType.decode(reader, reader.uint32());
          break;
        case 4:
          message.timestampNs = reader.uint64();
          break;
        case 5:
          message.kind = reader.int32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      requestId: isSet(object.requestId) ? String(object.requestId) : "",
      url: isSet(object.url) ? String(object.url) : "",
      encryptionKey: isSet(object.encryptionKey) ? DeviceSyncKeyType.fromJSON(object.encryptionKey) : undefined,
      timestampNs: isSet(object.timestampNs) ? Long.fromValue(object.timestampNs) : Long.UZERO,
      kind: isSet(object.kind) ? deviceSyncKindFromJSON(object.kind) : 0
    };
  },
  toJSON(message) {
    const obj = {};
    message.requestId !== undefined && (obj.requestId = message.requestId);
    message.url !== undefined && (obj.url = message.url);
    message.encryptionKey !== undefined && (obj.encryptionKey = message.encryptionKey ? DeviceSyncKeyType.toJSON(message.encryptionKey) : undefined);
    message.timestampNs !== undefined && (obj.timestampNs = (message.timestampNs || Long.UZERO).toString());
    message.kind !== undefined && (obj.kind = deviceSyncKindToJSON(message.kind));
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c;
    const message = createBaseDeviceSyncReply();
    message.requestId = (_a = object.requestId) !== null && _a !== void 0 ? _a : "";
    message.url = (_b = object.url) !== null && _b !== void 0 ? _b : "";
    message.encryptionKey = object.encryptionKey !== undefined && object.encryptionKey !== null ? DeviceSyncKeyType.fromPartial(object.encryptionKey) : undefined;
    message.timestampNs = object.timestampNs !== undefined && object.timestampNs !== null ? Long.fromValue(object.timestampNs) : Long.UZERO;
    message.kind = (_c = object.kind) !== null && _c !== void 0 ? _c : 0;
    return message;
  }
};
function createBaseDeviceSyncKeyType() {
  return {
    aes256Gcm: undefined
  };
}
export const DeviceSyncKeyType = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.aes256Gcm !== undefined) {
      writer.uint32(10).bytes(message.aes256Gcm);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceSyncKeyType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.aes256Gcm = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      aes256Gcm: isSet(object.aes256Gcm) ? bytesFromBase64(object.aes256Gcm) : undefined
    };
  },
  toJSON(message) {
    const obj = {};
    message.aes256Gcm !== undefined && (obj.aes256Gcm = message.aes256Gcm !== undefined ? base64FromBytes(message.aes256Gcm) : undefined);
    return obj;
  },
  fromPartial(object) {
    var _a;
    const message = createBaseDeviceSyncKeyType();
    message.aes256Gcm = (_a = object.aes256Gcm) !== null && _a !== void 0 ? _a : undefined;
    return message;
  }
};
function createBaseConsentUpdate() {
  return {
    entityType: 0,
    state: 0,
    entity: ""
  };
}
export const ConsentUpdate = {
  encode(message) {
    let writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.entityType !== 0) {
      writer.uint32(8).int32(message.entityType);
    }
    if (message.state !== 0) {
      writer.uint32(16).int32(message.state);
    }
    if (message.entity !== "") {
      writer.uint32(26).string(message.entity);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConsentUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.entityType = reader.int32();
          break;
        case 2:
          message.state = reader.int32();
          break;
        case 3:
          message.entity = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON(object) {
    return {
      entityType: isSet(object.entityType) ? consentEntityTypeFromJSON(object.entityType) : 0,
      state: isSet(object.state) ? consentStateFromJSON(object.state) : 0,
      entity: isSet(object.entity) ? String(object.entity) : ""
    };
  },
  toJSON(message) {
    const obj = {};
    message.entityType !== undefined && (obj.entityType = consentEntityTypeToJSON(message.entityType));
    message.state !== undefined && (obj.state = consentStateToJSON(message.state));
    message.entity !== undefined && (obj.entity = message.entity);
    return obj;
  },
  fromPartial(object) {
    var _a, _b, _c;
    const message = createBaseConsentUpdate();
    message.entityType = (_a = object.entityType) !== null && _a !== void 0 ? _a : 0;
    message.state = (_b = object.state) !== null && _b !== void 0 ? _b : 0;
    message.entity = (_c = object.entity) !== null && _c !== void 0 ? _c : "";
    return message;
  }
};
var globalThis = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
  if (globalThis.Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}
function base64FromBytes(arr) {
  if (globalThis.Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin = [];
    arr.forEach(byte => {
      bin.push(String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}
if (_m0.util.Long !== Long) {
  _m0.util.Long = Long;
  _m0.configure();
}
function isObject(value) {
  return typeof value === "object" && value !== null;
}
function isSet(value) {
  return value !== null && value !== undefined;
}
//# sourceMappingURL=content.pb.js.map